import actionCreatorFactory from 'typescript-fsa'

const actionCreator = actionCreatorFactory('SIDE_MENUS')

export const SideMenusActions = {
  switch: actionCreator<boolean>('SWITCH')
}
